import React from 'react'
import styled from 'styled-components'

const StyledDiv = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const TruncatedText = props => {
  return <StyledDiv {...props} />
}

TruncatedText.propTypes = {}

export default TruncatedText



// WEBPACK FOOTER //
// ./src/components/TruncatedText/index.js